import React from 'react';
import { useJobSummary } from '../../../Data/Jobs';
import Loading from '../../../Components/Loading';

import Section from '../../../Components/Containers/Section';
import Statuses from '../../../Components/Widgets/Jobs/Statuses';

const JobsSummary = ({title = 'Jobs'}) => {
    const {summary, isLoading}  = useJobSummary(true);

    return <Section title={title} isLoading={summary && isLoading}>
        {summary ? <Statuses className="-mt-2" jobs={summary.statuses} limit={Math.floor(window.innerWidth / 80)} /> : <Loading size="4x" center />}
    </Section>
}

export default JobsSummary;
